<template>
    <section class="z-accordion-panel" :class="accPanelClasses">
        <slot/>
    </section>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    verticalPadding: {
        type: Boolean,
        default: true
    },
    horizontalPadding: {
        type: Boolean,
        default: true
    },
    background: {
        type: Boolean,
        default: true
    },
    borders: {
        type: Boolean,
        default: false
    },
    size: {
        type: String,
        default: 'l',
        validator: (prop) => ['l', 'm', 's'].includes(prop)
    }
})

const accPanelClasses = computed(() => {
    return {
        'z-accordion-panel--vertical-padding': props.verticalPadding,
        'z-accordion-panel--horizontal-padding': props.horizontalPadding,
        'z-accordion-panel--borders': props.borders,
        'z-accordion-panel--bg': props.background,
        [`z-accordion-panel--size-${props.size}`]: props.size
    }
})
</script>

<style lang="scss">
@import './tokens.scss';

.z-accordion-panel {
    --bg-color: transparent;

    &--size-l {
        --padding-x: var(--padding-l);
        --padding-y: var(--padding-l);
    }

    &--size-m {
        --padding-x: var(--padding-m);
        --padding-y: var(--padding-m);
    }

    &--size-s {
        --padding-x: var(--padding-s);
        --padding-y: var(--padding-s);
    }

    &--bg {
        --bg-color: var(--panel-bg);
    }

    &--borders {
        border-bottom: var(--border-width) solid var(--border-color);
    }

    &:not(.z-accordion-panel--horizontal-padding) {
        --padding-x: 0;
    }

    &:not(.z-accordion-panel--vertical-padding) {
        --padding-y: 0;
    }
}

.z-accordion-panel {
    background: var(--bg-color);
    padding: var(--padding-y) var(--padding-x);
}
</style>
